import DOMPurify from "dompurify";
import { getDecodedHtml } from "utils/getDecodedHtml";

/**
 * Uses DOMPurify.santize and getDecodedHtml to clean up html string
 * @param {string} html The html that needs to be sanitized
 * @returns Santized html
 */
export const sanitizeHtml = (html: string | undefined): string => {
	if (html) {
		return DOMPurify.sanitize(getDecodedHtml(html));
	} else {
		return "";
	}
};
